import { c as _c } from "react/compiler-runtime";
import type { GetPublicPartnerCreatorRow } from '@morfi/backend-sdk-v2/client';
import { EditableAvatar } from '@/components/images/editable-avatar';
import { EditableHero } from '@/components/images/editable-hero';
import { HeroBanner } from '@/components/images/hero-banner';
import { OptimizedImage } from '@/components/images/optimized-image';
import { UserAvatar } from '@/components/images/user-avatar';
interface ProfileImagesProps {
  partnerProfile: GetPublicPartnerCreatorRow | undefined;
  userId: string;
  displayName: string | null;
  avatarUrl: string | null;
  heroUrl: string | null;
  avatarNsfw: boolean | null | undefined;
  coverNsfw: boolean | null | undefined;
  avatarRasterise: boolean | null | undefined;
  ownerRasterise: boolean;
  showOwnerEdit: boolean;
  handleHeroChange: (url: string) => void;
  handleAvatarChange: (url: string) => void;
}
export function ProfilePortfolioImages(t0) {
  const $ = _c(21);
  const {
    partnerProfile,
    userId,
    displayName,
    avatarUrl,
    heroUrl,
    avatarNsfw,
    coverNsfw,
    avatarRasterise,
    ownerRasterise,
    showOwnerEdit,
    handleHeroChange,
    handleAvatarChange
  } = t0;
  let t1;
  if ($[0] !== coverNsfw || $[1] !== displayName || $[2] !== handleHeroChange || $[3] !== heroUrl || $[4] !== partnerProfile || $[5] !== showOwnerEdit || $[6] !== userId) {
    t1 = partnerProfile ? partnerProfile.bannerUrl ? <div className="relative h-33 overflow-hidden rounded-t-card"><OptimizedImage variant="hero" nsfw={coverNsfw ?? false} src={partnerProfile.bannerUrl} alt="" className="h-33 w-full rounded-t-card object-cover" /></div> : <div className="h-33" /> : showOwnerEdit ? <EditableHero heroUrl={heroUrl} userId={userId} displayName={displayName} nsfw={coverNsfw ?? false} priority={true} onHeroChange={handleHeroChange} className="rounded-t-card" /> : <HeroBanner heroUrl={heroUrl} userId={userId} displayName={displayName} nsfw={coverNsfw ?? false} priority={true} preview={true} className="rounded-t-card" />;
    $[0] = coverNsfw;
    $[1] = displayName;
    $[2] = handleHeroChange;
    $[3] = heroUrl;
    $[4] = partnerProfile;
    $[5] = showOwnerEdit;
    $[6] = userId;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== avatarNsfw || $[9] !== avatarRasterise || $[10] !== avatarUrl || $[11] !== displayName || $[12] !== handleAvatarChange || $[13] !== ownerRasterise || $[14] !== partnerProfile || $[15] !== showOwnerEdit || $[16] !== userId) {
    t2 = <div className="absolute -bottom-12 left-4 sm:left-6">{partnerProfile ? <OptimizedImage variant="avatar" nsfw={avatarNsfw ?? false} src={partnerProfile.avatarUrl} alt="" size={96} className="size-24 rounded-full object-cover ring-4 ring-background-primary" /> : showOwnerEdit ? <EditableAvatar size="3xl" userId={userId} displayName={displayName} avatarUrl={avatarUrl} nsfw={avatarNsfw ?? null} rasterise={ownerRasterise} onAvatarChange={handleAvatarChange} avatarClassName="ring-4 ring-background-primary" /> : <UserAvatar size="3xl" userId={userId} displayName={displayName} avatarUrl={avatarUrl} nsfw={avatarNsfw ?? false} rasterise={avatarRasterise ?? false} preview={true} className="ring-4 ring-background-primary" />}</div>;
    $[8] = avatarNsfw;
    $[9] = avatarRasterise;
    $[10] = avatarUrl;
    $[11] = displayName;
    $[12] = handleAvatarChange;
    $[13] = ownerRasterise;
    $[14] = partnerProfile;
    $[15] = showOwnerEdit;
    $[16] = userId;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  let t3;
  if ($[18] !== t1 || $[19] !== t2) {
    t3 = <div className="relative" aria-hidden="true">{t1}{t2}</div>;
    $[18] = t1;
    $[19] = t2;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  return t3;
}